export default () => ({
	notifications: []
})
